import styled from 'styled-components';
export var StyledChipSpinner = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledChipSpinner",
  componentId: "c11n-8-99-3__sc-1ab09lt-0"
})([""]);